import { createFileRoute } from "@tanstack/react-router";
import { StatisticsContainer } from "../../app/views/statistics/statisticsContainer";

export const Route = createFileRoute("/statistics")({
  component: StatisticsContainer,
});
